export default "__VITE_ASSET__BLEkfCY0__"